import styled from "styled-components";
import struttura from '../images/struttura.jpg' 
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

const PrevAbout = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 668px)' });
  const { t } = useTranslation();
  let str = t('chiSiamoDescrizione');
  let words = str.split(" ");
  let result = words.slice(0, 74).join(" ") + "...";
  return <Wrapper>
      <div className="container">
        <div className="row">
            <div className="col-12 col-md-6" style={isMobile ? {padding: '30px 5px 5px'} : {padding: '50px 25px'}}>
                <div className="card">
                    <img src={struttura} alt="" />
                </div>
            </div>
            <div className="col-12 col-md-6" style={isMobile ? {padding: '10px 5px 30px'} : {padding: '50px 25px'}}>
                <div className="card text">
                    <h3>{t('chiSiamo')}</h3>
                    <p>{result}</p>
                    <Link to='/about' className='link'>{t('leggiAltro')}</Link>
                </div>
            </div>
        </div>
      </div>
    </Wrapper>
}

export default PrevAbout

const Wrapper = styled.section`
    /* padding-bottom: 30px; */
    .container {
        .row {
            justify-content: center;
            .col-12 {
                padding: 50px 25px;
                .card {
                    &.text {
                        padding: 30px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: flex-start;
                    }
                    h3 {
                        padding-right: 5px;
                        font-size: 20px;
                        color: var(--logo);
                        text-transform: uppercase;
                        border-bottom: 2px solid var(--logo);
                    }
                    .link {
                        color: white;
                        font-size: 12px;
                        font-weight: lighter;
                        padding: 3px 9px;
                        border-radius: 5px;
                        text-transform: uppercase;
                        background-color: var(--footer);
                    }
                    p {
                        margin: 10px 0px 15px 0px;
                        line-height: 24px;
                    }
                    width: 100%;
                    overflow: hidden;
                    background-color: var(--gray);
                    border-radius: 10px;
                    img {
                        display: block;
                        width: 100%;
                        border-radius: 10px;
                        height: 100%;
                        object-fit: cover;
                        object-position: center;
                    }
                }
            }
        }
    }
`